// Copyright (c) 2016 Deere & Company

import Report, {getDefaultState} from '../state/report';
import actions from '../../actions-list';

const updateClaimHistoryReport = (state, action) =>
    Report.update(state, {
        $set: action.data
    });

const resetClaimHistoryReport = () => getDefaultState();

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.CREATE_CLAIM_HISTORY_REPORT_SUCCESS]: updateClaimHistoryReport,
        [actions.RESET_CLAIM_HISTORY_REPORT]: resetClaimHistoryReport
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/claim-history/reducers/report.js